function findTarget (selector, event) {
  var element = event.target || event.srcElement;
  return element.closest(selector);
}

function clearDOM (element) {
  while (element.hasChildNodes()) element.removeChild(element.lastChild);
}

module.exports = {
  findTarget: findTarget,
  clearDOM: clearDOM
};



//////////////////
// WEBPACK FOOTER
// ./_js/utils.js
// module id = 0
// module chunks = 0 1 2 3 4 5 6 7